module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submit":"Save","title":"Add site"}}')
  delete Component.options._Ctor
}
